import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// RentCollectionActivityDto (Módulo 5) — uma ação do workflow de cobrança de rendas
// em atraso [5.4.2]. camelCase pinado a partir do contrato do backend.
export interface RentCollectionActivity {
  id: number;
  rentNoticeId: number;
  tenantName: string;
  propertyName: string;
  // Fase de escalada: "due_notice" | "soft" | "firm".
  stage: string;
  stageName: string;
  channel: string;
  channelName: string;
  activityDate: string;
  subject: string | null;
  body: string | null;
  outcome: string | null;
  emailTo: string | null;
  emailStatus: string | null;
  createdBy: string | null;
}

// Corpo de POST /api/rent-collections/log — registo manual de uma ação.
export interface LogRentCollectionPayload {
  rentNoticeId: number;
  stage: string;
  channel: string;
  outcome?: string | null;
  subject?: string | null;
  body?: string | null;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

// Histórico de ações de cobrança de um aviso de renda, desc por data.
export function getRentCollectionActivities(
  rentNoticeId: number,
): Promise<RentCollectionActivity[]> {
  return request<RentCollectionActivity[]>(
    `/api/rent-collections?rentNoticeId=${rentNoticeId}`,
  );
}

// Envia (stub/log) o email de cobrança para a fase indicada e regista a ação.
export function sendRentCollectionEmail(
  rentNoticeId: number,
  stage: string,
): Promise<RentCollectionActivity> {
  return request<RentCollectionActivity>("/api/rent-collections/send-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ rentNoticeId, stage }),
  });
}

// Regista manualmente uma ação de cobrança (chamada, nota, carta…).
export function logRentCollectionActivity(
  payload: LogRentCollectionPayload,
): Promise<RentCollectionActivity> {
  return request<RentCollectionActivity>("/api/rent-collections/log", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
